import { onMounted, ref } from "vue";

const startTime = ref<number | null>(null);

export function useTimer() {
  const startTimer = () => {
    if (startTime.value === null) {
      startTime.value = Date.now();
    }
  };

  const getElapsedTime = (): number => {
    if (startTime.value === null) return 0;
    return Math.floor((Date.now() - startTime.value) / 1000);
  };

  const resetTimer = () => {
    startTime.value = null;
  };

  onMounted(() => {
    startTimer();
  });

  return {
    startTimer,
    getElapsedTime,
    resetTimer
  };
}
